"use client";

import Link from "next/link";
import { useUserLists } from "@/components/UserListsProvider";

function HeartIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24">
      <path
        d="M12 20.2 4.9 13.4a4.9 4.9 0 0 1 6.9-7l.2.2.2-.2a4.9 4.9 0 0 1 6.9 7Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
    </svg>
  );
}

export function HeaderFavoritesButton() {
  const { favoriteCount, isAuthenticated } = useUserLists();

  return (
    <Link
      className="header-action-link"
      href={isAuthenticated ? "/favorites" : "/account/login?next=%2Ffavorites"}
    >
      <span className="header-action-icon">
        <HeartIcon />
      </span>
      <span className="header-action-label">Избранное</span>
      {isAuthenticated && favoriteCount > 0 ? <span className="header-action-count">{favoriteCount}</span> : null}
    </Link>
  );
}
